<h6 class="result-not-found-label"> No Results Found For Your Marketplace Search. </h6>
<h6 class="mb-5"> <button (click)="resultNotFoundGuidance()">Click Here</button> For Additional Guidance From Our Team</h6>